import { render, staticRenderFns } from "./CircoloCura.vue?vue&type=template&id=5893fb2a&"
import script from "./CircoloCura.vue?vue&type=script&lang=js&"
export * from "./CircoloCura.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports